import { render } from "./SideBarMovilSettings.vue?vue&type=template&id=5f3fec11"
import script from "./SideBarMovilSettings.vue?vue&type=script&lang=js"
export * from "./SideBarMovilSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__